const StatCard = ({ title, value, icon }) => (
    <div className="bg-white bg-opacity-20 rounded-lg p-4">
        <div className="flex items-center justify-between">
            <div>
                <p className="text-white text-opacity-75 text-sm">{title}</p>
                <p className="text-2xl font-bold text-white">{value}</p>
            </div>
            <div className="text-3xl">{icon}</div>
        </div>
    </div>
);

export default StatCard;